<script setup>
import SavedCard from '@/Components/Payments/SavedCard.vue'
import { ref, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { usePaymentsStore } from '@/Stores/payments'
const payments = usePaymentsStore()

const { savedCards } = storeToRefs(payments)

const props = defineProps({
	cardableId: {
		required: true
	},
	selectedCard: {
		type: Object,
		default: null,
	},
});

const emit = defineEmits([
	'select-card',
]);

function selectCard(card){
	emit('select-card', card)
}

</script>

<template>
	<div class="saved-cards mb-4" data-testid="saved-cards-list">
		<Label>Saved Cards</Label>
		<div v-if="savedCards === null" class="text-center">
            <Spinner size="md" color="blue" />
		</div>
		<div v-else-if="savedCards.length === 0" class="text-center my-12">
			<p class="text-gray-500 text-sm italic">No saved cards</p>
		</div>
		<div v-else>
			<SavedCard 
				v-for="card in savedCards" 
				:key="card.maskedCardNumber"
				:card="card"
				:selected="card.id === selectedCard?.id"
				@click="selectCard(card)"
				data-testid="saved-card-list-item"
			/>
		</div>
	</div>
</template>
